<template>
  <!-- 查看大图 -->
  <div>
    <div
      :ref="`viewer${rowId}${identify}`"
      v-viewer="{title: false}"
      class="img-box"
    >
      <div v-if="imageList.length > 0">
        <template v-if="isLink">
          <div
            v-for="(image, index) in images"
            :key="index"
            :image="image"
          >
            <div>
              <el-link
                :underline="false"
                type="primary"
                @click="handlePicturePreview(image.url, index)"
              >查看</el-link>
              <!-- 图片查看器(兼容ie) -->
              <el-image
                ref="preview"
                class="hideImgDiv"
                :src="image.url"
                :preview-src-list="[image.url]"
                :z-index="9999"
              ></el-image>
            </div>
          </div>
        </template>
        <template v-else-if="isOwn">
          <image-item
            v-for="(image, index) in images"
            :key="index"
            :image="image"
          >
            <div class="image-item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(image.url, index)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
            </div>
          </image-item>
        </template>
        <template v-else>
          <div
            v-for="(imageUrl, index) in imageList"
            :key="index"
          >
            <span
              class="img-message"
              @click="handlePictureCardPreview(imageUrl, index)"
              :style="{
                display: index > 0 ? 'none' : 'block',
                width: size+'px',
                height: size+'px'
              }"
            >
              <el-image
                class="fan-img"
                fit="cover"
                :src="imageUrl"
              >
                <div
                  slot="error"
                  class="image-error-slot"
                  :style="{
                    lineHeight: size+'px'
                  }"
                >
                  <icon-svg
                    v-if="imageUrl.includes('.pdf')"
                    name="pdf"
                  />
                  <icon-svg
                    v-else
                    name="img-error"
                  />
                </div>
              </el-image>
              <span class="img-message-text">
                {{imageList.length}}张
              </span>
            </span>
          </div>
        </template>
      </div>
    </div>
    <!-- PDF查看 -->
    <preview-pdf
      :visible.sync="pdfVisible"
      :pdf-url="pdfUrl"
    />
  </div>
</template>

<script>
import { ImageItem } from '@/components/upload';
import previewPdf from '../preview-pdf';

export default {
  name: 'selectDepartment',
  components: { ImageItem, previewPdf },
  props: {
    // 图片集合
    imageList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 标识id
    rowId: {
      type: [Number, String],
      default: 0,
    },
    identify: {
      type: String,
      default: 'card',
    },
    size: {
      type: Number,
      default: 50,
    },
    isOwn: {
      type: Boolean,
      default: false,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewer: null, // 图片查看大图
      pdfVisible: false,
      pdfUrl: '',
    };
  },
  created() {
    this.images = this.imageList.map((item) => {
      return { url: item };
    });
  },
  methods: {
    handlePictureCardPreview(file, index) {
      const isPdf = file.includes('.pdf');
      if (isPdf) {
        // window.open(file);
        this.pdfVisible = true;
        this.pdfUrl = file.replace(/^(http:)/, 'https:');
      } else {
        const images = [];
        let imageIndex = index;
        this.imageList.forEach((it) => {
          if (!it.includes('.pdf')) {
            images.push(it);
          }
        });
        imageIndex = images.findIndex((el) => el === file);
        const viewer = this.$refs[`viewer${this.rowId}${this.identify}`].$viewer;
        viewer.view(imageIndex);
      }
    },
    handlePicturePreview(file, index) {
      // 调用image组件中的大图浏览图片方法
      this.$refs.preview.showViewer = true;
      const viewer = this.$refs[`viewer${this.rowId}${this.identify}`].$viewer;
      viewer.view(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.img-box {
  position: relative;
}
// 查看图片大图
.img-message {
  position: relative;
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  cursor: pointer;
  margin: auto;
  border-radius: 4px;
  overflow: hidden;
  .fan-img {
    width: 100%;
    height: 100%;
  }
  .image-error-slot {
    width: 100%;
    height: 100%;
    font-size: 25px;
    .icon-svg {
      width: 100%;
      height: 100%;
      vertical-align: 0;
    }
  }
  &-text {
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
    opacity: 0.7;
    padding: 0 6px;
    color: #ffffff;
    background: #000000;
  }
}

/*隐藏el-image图片组件中不需要展示的的img标签*/
.hideImgDiv {
  ::v-deep {
    .el-image__inner {
      display: none;
    }
  }
}
</style>
